import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  DropdownWidth,
  DropdownItemComponent,
  IconComponent,
  DropdownHeaderComponent,
  DropdownComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-search-page-query-input-info',
  templateUrl: './query-input-info.component.html',
  styleUrls: ['./query-input-info.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownComponent,
    DropdownHeaderComponent,
    IconComponent,
    DropdownItemComponent,
    TranslatePipe,
  ],
})
export class SearchPageQueryInputInfoComponent {
  private readonly i18n = inject(I18nService);

  public readonly fields = input<
    Array<{
      icon: IconName;
      label: string;
    }>
  >(undefined!);
  public readonly readMoreLink = input<string>(undefined!);

  public DropdownWidth = DropdownWidth;

  public operators: Array<{ label: string; description: string }> = [
    {
      label: '<span>and</span>',
      description: this.i18n.translate('app.new_search_page.boolean_search_info.operators.and'),
    },
    {
      label: '<span>or</span>',
      description: this.i18n.translate('app.new_search_page.boolean_search_info.operators.or'),
    },
    {
      label: '<span>not</span>',
      description: this.i18n.translate('app.new_search_page.boolean_search_info.operators.not'),
    },
    {
      label: '<span>(</span>&nbsp;parentheses&nbsp;<span>)</span>',
      description: this.i18n.translate(
        'app.new_search_page.boolean_search_info.operators.parentheses',
      ),
    },
    {
      label: '<span>"</span>&nbsp;quotes&nbsp;<span>"</span>',
      description: this.i18n.translate('app.new_search_page.boolean_search_info.operators.quotes'),
    },
  ];

  public trackByIndex(index: number): number {
    return index;
  }

  public preventNonAnchorEventBubbling($event: MouseEvent): void {
    if ($event.target && !('href' in $event.target)) {
      $event.preventDefault();
    } else {
      $event.stopPropagation();
    }
  }
}
